


























































































































import hash from 'object-hash';
import _ from 'lodash';
import { editFactory } from '@/main/pages';
import { ZAKAZKA_DRUH } from '@/modules/servis/zakazka/constants';
import { mapActions } from 'vuex';
import { PAGE_MGR_CLEAR } from '@/main/store/actionTypes';
import { Dodavatel } from '@/modules/ciselnik/skladove/dodavatel';
import { saveButton, deleteButton } from '@/main/utils/tableOperations';
import { formatDecimalValue } from '@/main/utils/stringHelper';

import { showAlert } from '@/main/utils/notifications';

import { Row } from '@/main/utils/table';
import { isUserPartsManager, OpenPartMaintenance } from '@/main/utils/commonFunctions';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';
import DmsPdfDialog from '#components/DmsPdfDialog.vue';


import { store } from './store/edit';
import { apiProvider, prijemkaTiskUrl, partsPurInvoiceUrl } from './api';
import { REPORT_FILE_TYPE } from '../constants';
import PRInvoiceSelect from './components/Select.vue';
import { editMutations } from './store/types';
import { NAME, POLOZKY, DEPENDENT_TABLES, POLOZKY_COLS, TRANSACTION_TYPE, TAB_NAMES, TABS, PR_INVOICE, GRID_COLUMNS } from './constants';


const KEY_COLUMN_INDEX = '5';

export default editFactory(NAME, store).extend({
	components: { DmsPdfDialog, DmsEditableTable, PRInvoiceSelect, DodavatelSelect: Dodavatel.components.Select },
	data() {
		return {
			isApproveShow: false,
			rowKey: KEY_COLUMN_INDEX,
			polozkyCols: POLOZKY_COLS,
			showTiskDialog: false,
			showPartPurchaseInvoiceDialog: false,
			prijemkaTiskUrl,
			partsPurInvoiceUrl,
			prInvoiceFlag: false,
			isPRInvoiceFlag: false,
			ndpohybdoklId: 0,
			dialog: {
				visible: false,
				rpzv: false,
				klonZakazky: false,
				title: '',
			},
			displayErrorMessage: false,
			klonovanaZakazkaDruh: ZAKAZKA_DRUH.DILENSKA,
			reportType: null as string | null,
			dependencies: DEPENDENT_TABLES,
			showCreatePolozky: true,
			prReceiptButtonPrp: false,
			fileList: [] as any[],
			saveButton,
			deleteButton,
			cellIndex: 0,
			isPartsRefresh: false,
			isPartPurchaseOrderDisplay: false,
			multipleSelection: [],
			gridCols: GRID_COLUMNS,
		};
	},
	computed: {
		isUserPartsManager(): boolean {
			return isUserPartsManager(this.pracovnik.PracovnikOzn, this.userRoles);
		},
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(NAME, TABS.hlavni)) tabItems.push(TAB_NAMES.HLAVNI);

			return _.pick(TABS, tabItems);
		},
		mutationsMappers(): Record<string, string> {
			return {
				dodavatel: `${this.storeUri}/${editMutations.ND_PRIJEMKA_DODAVATEL_SELECT_MAPPER}`,
				PRInvoice: `${this.storeUri}/${editMutations.PRINVOICE_INVOICE_SELECT_MAPPER}`,
			};
		},
		prInvoiceTitle(): string {
			return this.LocalizePopisostatni('PRInvoiceTitle');
		},
		vozidloFilter(): object {
			return {
				PrijemkaId: this.PrijemkaId,
				DodavatelId: this.DodavatelId,
			};
		},
		localizePolozky(): string {
			return this.LocalizePopisostatni('POLOZKY');
		},
		showRefresh(): boolean {
			return this.PRInvoicePaymentId! <= 0;
		},
		isPaymentDone(): boolean {
			return (this.edit.PRInvoicePaymentId! > 0);
		},
		isReceiptSelected(): boolean {
			return this.edit.InvoiceNumber !== null;
		},
		dependeciesByFilter(): string[] {
			return [POLOZKY];
		},
		isFormDataChanged(): boolean {
			return hash(this.edit) !== this.editHash || hash(this.dependentTables.Polozky.rows) !== this.dependentTables.Polozky.hash;
		},
		prijemkaTiskFilter(): object {
			return {
				PrijemkaId: this.PrijemkaId,
				PRInvoiceFlag: this.prInvoiceFlag,
				NdpohybdoklId: this.ndpohybdoklId,
				PrintDialog: true,
				ReportType: REPORT_FILE_TYPE[REPORT_FILE_TYPE.PDF],
			};
		},
		formattedTotalPrice(): string | null {
			return this.TotalPrice != null ? formatDecimalValue(this.TotalPrice) : this.TotalPrice;
		},
		formattedTotalPriceWithGst(): string | null {
			return this.TotalPriceWithGst != null ? formatDecimalValue(this.TotalPriceWithGst) : this.TotalPriceWithGst;
		},
		formattedTotalPriceWithVat(): string | null {
			return this.TotalPriceWithVat != null ? formatDecimalValue(this.TotalPriceWithVat) : this.TotalPriceWithVat;
		},
		formattedOutStandingAmount(): string | null {
			return this.OutStandingAmount != null ? formatDecimalValue(this.OutStandingAmount) : this.OutStandingAmount;
		},
		formattedVatAmount(): string | null {
			return this.VatAmount != null ? formatDecimalValue(this.VatAmount) : this.VatAmount;
		},
	},
	methods: {
		onHyperLinkClick({ row } : { row : Row }) {
			OpenPartMaintenance({ cellNames: this.dependentTables.Polozky.cellNames, row });
		},
		...mapActions({
			clearPages: `pageManager/${PAGE_MGR_CLEAR}`,
		}),
		async saveClick(isPageRfersh = true) {
			 if (!this.customValidation()) {
				return;
			 }
			 if (isPageRfersh) {
				this.refreshPreviousPage = true;
				await this.UPDATE({ id: this.edit.PRInvoicePaymentId ?? 0, goBack: true });
			} else {
				this.refreshPreviousPage = false;
				await this.UPDATE({ id: this.edit.PRInvoicePaymentId ?? 0, goBack: false });
			}
			
		},
		closePopup() {
			this.displayErrorMessage = false;
		},
		customValidation() {
			this.displayErrorMessage = false;
			if (this.isCreateMode) {
				if (!this.DodavatelId || this.DodavatelId <= 0) {
					showAlert({
						message: this.LocalizeChyboveHlasky('SUPPLIER_MANDATORY'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return false;
				}
				if (!this.isPartsRefresh) {
					showAlert({
						message: this.LocalizeChyboveHlasky('Part_Refresh'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return false;
				}
				if ((this.edit.Amount === null || this.edit.Amount <= 0)
				|| (this.edit.OutStandingAmount === null || this.edit.OutStandingAmount <= 0) || (this.edit.Amount > this.edit.OutStandingAmount)) {
					this.displayErrorMessage = true;
					return false;
				}
			}
			return true;
		},
		async refreshPolozky() {
			this.isPartsRefresh = true;
			if (!this.customValidation()) {
				return;
			}
			if (this.isCreateMode && this.PrInvoiceId !== null) {
				this.startLoading();
				this.edit.CreatedBy = this.pracovnik.PracovnikId;
				const { data: CheckInvoiceStatus } = await apiProvider.CheckPRInvoiceExists(this.edit);
				if (CheckInvoiceStatus) {
				showAlert({
					message: this.LocalizeChyboveHlasky('PRInvoice_Exists'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				this.endLoading();
				return;
				}
				else{
				const prreturn = await apiProvider.savePRInvoicePayment(this.edit);
				if (prreturn instanceof Error) {
					this.endLoading();
					return;
				}
				if (prreturn.data > 0) {
					this.edit.PRInvoicePaymentId = prreturn.data;
					await apiProvider.saveGRNParts(this.edit);
				}
				this.endLoading();
				await this.changeUrlToEdit(this.PRInvoicePaymentId!);
				await this.refreshTable(POLOZKY);
				if (!this.mainCollapse.includes(POLOZKY)) {
					this.mainCollapse.push(POLOZKY);
				}
				this.startLoading();
				await this.saveClick(false);
				this.endLoading();
			}
			} else {
				this.startLoading();
				const { data: isDataSaved } = 	await apiProvider.saveGRNParts(this.edit);
				if (!isDataSaved) {
					showAlert({
						message: this.LocalizeChyboveHlasky('GRN_EXIST'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					this.endLoading();
					return;
				}
				this.endLoading();
				await this.changeUrlToEdit(this.PRInvoicePaymentId!);
				await this.refreshTable(POLOZKY);
				if (!this.mainCollapse.includes(POLOZKY)) {
					this.mainCollapse.push(POLOZKY);
				}
			}
			this.selectChange();
		},
		onValueupdate() {
			if (this.edit.Amount !== null && this.edit.OutStandingAmount !== null && this.edit.Amount > this.edit.OutStandingAmount) {
				this.displayErrorMessage = true;
			}
		},
		async loadData() {
			if (this.isCreateMode) {
				await this.default();
			} else {
				await this.entity();
			}
			await this.fetchTableSchemaData(this.dependenciesById);
			await this.fetchTableSchemas(this.dependeciesByFilter);
			await this.fetchTableData(this.dependeciesByFilter);
			await this.loadedData();
		},
		async printInvoice() {
			this.showTiskDialog = true;
		},

		async onPrintDialogClosed() {
			this.showTiskDialog = false;
			this.refreshPreviousPage = true;
			await this.changeUrlToEdit(this.edit.PRInvoicePaymentId!);
		},
		async markReportAsPrinted() {
			this.reportType = REPORT_FILE_TYPE[REPORT_FILE_TYPE.PDF];
			await apiProvider.markReportAsPrinted(this.PrijemkaId, this.reportType);
		},
		selectChange() {
			if (this.TransactionStatus === TRANSACTION_TYPE.FULL_PAYMENT) {
				if(this.dmsSys.EnableGSTPrp){
					if (this.edit.TotalPriceWithGst === this.edit.OutStandingAmount) {
					this.edit.Amount = this.edit.TotalPriceWithGst;
				} 	else if (this.edit.TotalPriceWithGst !== null && this.edit.OutStandingAmount !== null && this.edit.TotalPriceWithGst > this.edit.OutStandingAmount) {
					this.edit.Amount = this.edit.OutStandingAmount;
				} 	else {
					this.edit.Amount = 0;
				}
				}
				if(this.dmsSys.EnableVATPrp){
					if (this.edit.TotalPriceWithVat === this.edit.OutStandingAmount) {
					this.edit.Amount = this.edit.TotalPriceWithVat;
				} 	else if (this.edit.TotalPriceWithVat !== null && this.edit.OutStandingAmount !== null && this.edit.TotalPriceWithVat > this.edit.OutStandingAmount) {
					this.edit.Amount = this.edit.OutStandingAmount;
				} 	else {
					this.edit.Amount = 0;
				}
				}
				this.isPaymentDone = true;
			} else {
				this.edit.Amount = 0;
				this.isPaymentDone = false;
			}
			this.isPaymentDone = false;
		},
		handleSelection(rows: []) {
			this.multipleSelection = rows;
		},
		async isPartLocked() {
			await this.fetchTableSchemas([PR_INVOICE]);
			const data =	await apiProvider.prInvoiceFiler();
			this.props.filter = data.data.Filter;
			await this.fetchTableData([PR_INVOICE]);
			this.isPartPurchaseOrderDisplay = true;
		},
		async getSelectedParts() {
			const idColumnIndex = this.dependentTables.PRInvoice!.cellNames!.idColumn;
			const checkboxColumnIndex = this.dependentTables.PRInvoice!.cellNames!.CHECKBOX;
			const supplierIdex = this.dependentTables.PRInvoice!.cellNames!.DODAVATEL_ID;
			const PrijemkaIdIndex = this.dependentTables.PRInvoice!.cellNames!.PRIJEMKA_ID;
			const PrijemkaNrIndex = this.dependentTables.PRInvoice!.cellNames!.PRIJEMKA_NAD;
			const remainingAmountIndex = this.dependentTables.PRInvoice!.cellNames!.REM_AMOUNT;
			const totalPriceIndex = this.dependentTables.PRInvoice!.cellNames!.TOTAL_PAYMENT; 
			const totalPriceWithGstIndex = this.dependentTables.PRInvoice!.cellNames!.TOTAL_PAYMENT_WITH_GST; 
			const gstAMTIndex = this.dependentTables.PRInvoice!.cellNames!.GST_AMT; 
			const vatAmountIndex = this.dependentTables.PRInvoice!.cellNames!.VAT_AMT; 
			const totalPriceWithVatIndex = this.dependentTables.PRInvoice!.cellNames!.TOTAL_PAYMENT_WITH_VAT; 
			const supplierTextIndex = this.dependentTables.PRInvoice!.cellNames!.SUPPLIER; 

			const vatAMT = this.multipleSelection.map((s: any) => [s.cells[vatAmountIndex]]);
			const totalPriceWithVat = this.multipleSelection.map((s: any) => [s.cells[totalPriceWithVatIndex]]);
			const supplier = this.multipleSelection.map((s: any) => [s.cells[supplierTextIndex]]);
			const supplierId = 	this.multipleSelection.map((s: any) => [s.cells[supplierIdex]]);
			const recieptId = 	this.multipleSelection.map((s: any) => [s.cells[PrijemkaIdIndex]]);
			const invoiceNo = this.multipleSelection.map((s: any) => [s.cells[PrijemkaNrIndex]]);
			const remainingAmount = this.multipleSelection.map((s: any) => [s.cells[remainingAmountIndex]]);
			const totalPrice = this.multipleSelection.map((s: any) => [s.cells[totalPriceIndex]]);
			
			const selectedValues = this.multipleSelection;
			this.edit.PrInvoiceId = recieptId[0][0];
			this.edit.PrijemkaId = recieptId[0][0];
			this.edit.InvoiceNumber = invoiceNo[0][0];
			this.edit.TotalPrice = eval(totalPrice.join("+"));
			this.edit.OutStandingAmount =  eval(remainingAmount.join("+"));
			this.edit.TotalPriceWithVat =  eval(totalPriceWithVat.join("+"));
			this.edit.VatAmount = eval(vatAMT.join("+"));
			this.edit.DodavatelId = supplierId[0][0];
			this.edit.DodavatelIdText = supplier[0][0];


			if (selectedValues.length === 0) {
				showAlert({
					message: this.LocalizeChyboveHlasky('PartsReturn'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			} 
			else {
				const selectedValuesWithIndex = this.multipleSelection.map((s: any) => [s.cells[PrijemkaIdIndex]]);
				if (this.isCreateMode && this.PrInvoiceId !== null) {
				this.startLoading();
				const { data: CheckInvoiceStatus } = await apiProvider.CheckPRInvoiceExists(this.edit);
				if (CheckInvoiceStatus) {
				showAlert({
					message: this.LocalizeChyboveHlasky('PRInvoice_Exists'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				this.endLoading();
				return;
				}
				else{
				const prreturn = await apiProvider.savePRInvoicePayment(this.edit);
				if (prreturn instanceof Error) {
					this.endLoading();
					return;
				}
				if (prreturn.data > 0) {
					this.edit.PRInvoicePaymentId = prreturn.data;
					await apiProvider.savePartsList(this.edit,selectedValuesWithIndex);
				}
				this.endLoading();
				await this.changeUrlToEdit(this.PRInvoicePaymentId!);
				await this.refreshTable(POLOZKY);
				if (!this.mainCollapse.includes(POLOZKY)) {
					this.mainCollapse.push(POLOZKY);
				}
			}
			} else {
				this.startLoading();
				const { data: isDataSaved } = 	await apiProvider.savePartsList(this.edit,selectedValuesWithIndex);
				if (!isDataSaved) {
					showAlert({
						message: this.LocalizeChyboveHlasky('GRN_EXIST'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					this.endLoading();
					return;
				}
				this.endLoading();
				await this.changeUrlToEdit(this.PRInvoicePaymentId!);
				await this.refreshTable(POLOZKY);
				if (!this.mainCollapse.includes(POLOZKY)) {
					this.mainCollapse.push(POLOZKY);
				}
			}
			this.selectChange();
			this.isPartPurchaseOrderDisplay = false;
			}
		},
	},
});
